import { Theme } from "@emotion/react";
import { SxProps } from "@mui/material";

import theme from "~frontend/theme";

export const spacingArray = (spacing: number[]): string => {
  return spacing.map(space => theme.spacing(space)).join(" ");
};

export function noBorderBottomIf(condition: boolean): SxProps<Theme> {
  return condition
    ? {
        borderBottom: "none",
      }
    : {};
}
